/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { StatsRecord } from "~/features/dashboard/types";
import { TotalStats } from "~/features/statistics/types";

const transformToStats = (apiData: TotalStats["data"]): Record<string, StatsRecord[]> => {
  const transformed: Record<string, StatsRecord[]> = {};

  apiData.items.forEach((site) => {
    site.details.forEach((detail) => {
      if (!transformed[String(detail.reportDate)]) {
        transformed[String(detail.reportDate)] = [];
      }
      transformed[String(detail.reportDate)].push({
        date: String(detail.reportDate),
        netRevenue: Number(detail.netRevenue),
        grossRevenue: Number(detail.successfulThrustsAmount),
        premiumJoins: Number(detail.premiumJoins),
        nonPremiumJoins: Number(detail.nonPremiumJoins),
        newPayingUsers: Number(detail.newPayingUsers),
        logins: Number(detail.uniqueLogins),
        clicks: Number(detail.totalClicks),
        domain: detail.siteDomain,
      });
    });
  });
  return transformed;
};

export default transformToStats;
